import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { SUBMENU_NAV, NavListModule, NavListItem, getBaseUrlClean } from 'src/app/core/services/navigation.service';
import { Globals } from 'src/app/globals';
import { ICON_CONFIG } from '@core/models/icons.model';
import { BaseComponent } from '@shared/components/base/base.component';
import { UserStateService } from '@core/services/user-state.service';
import { NavigationStateService } from '@core/services/navigation-state.service';
import { MsalService } from '@azure/msal-angular';
import {TranslocoDirective, TranslocoModule, TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import { IntegrationDashboardDataService } from "@modules/integration-dashboard/services/integration-dashboard-data.service";
import { SurveysService } from '@modules/client/services/surveys.service';
import {MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatSidenav, MatSidenavContainer, MatSidenavContent} from "@angular/material/sidenav";
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {MatList, MatListItem, MatListModule, MatListSubheaderCssMatStyler, MatNavList} from "@angular/material/list";
import {MatIcon} from "@angular/material/icon";
import {MatToolbar, MatToolbarRow} from "@angular/material/toolbar";
import {AsyncPipe, NgClass, NgForOf} from "@angular/common";
import {MatLine} from "@angular/material/core";

const profileIcon = ICON_CONFIG.profile;
const languageIcon = ICON_CONFIG.language;
const langIcon = ICON_CONFIG.filterClose;

@Component({
  selector: 'app-navigation',
  templateUrl: '/navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  imports: [
    MatMenu,
    MatSidenavContent,
    RouterOutlet,
    MatMenuTrigger,
    MatListItem,
    RouterLink,
    MatIcon,
    MatNavList,
    RouterLinkActive,
    MatSidenavContainer,
    MatSidenav,
    MatToolbarRow,
    MatToolbar,
    TranslocoPipe,
    TranslocoModule,
    AsyncPipe,
    NgForOf,
    NgClass,
    MatListSubheaderCssMatStyler,
    MatMenuItem,
    MatLine,
    MatMenuContent,
    MatList,
    MatListModule,
    TranslocoDirective
  ],
})
export class NavigationComponent extends BaseComponent implements OnDestroy, OnInit {
  public subscriptions: Subscription[] = [];
  public applicationTitle = '';
  public open = true;
  public isLoggedIn = false;
  public activeModule: string;
  public activeSubModule: string;
  public profileIcon: string;
  public langIcon: string;
  public languageIcon: string;
  public activeLang: string = 'EN';
  public surveysEnabled = false;
  // public sideNavLinks: NavListModule[];
  public headerMenuLinks: NavListItem[];

  constructor(
    public globals: Globals,
    public msalService: MsalService,
    public userStateSvc: UserStateService,
    public navigationStateService: NavigationStateService,
    private transloco: TranslocoService,
    private intDashSvc: IntegrationDashboardDataService,
    private surveysService: SurveysService
  ) {
    console.log('🧭 NavigationComponent constructor called');
    
    super();
    this.activeLang = 'asdfasdf';
    // if this is "home" or starting the app -> then reset all keys & navigation
    // listen for navigation update events
  }

  async ngOnInit() {
    console.log('🧭 NavigationComponent ngOnInit called');
      
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.sideNavLinks = MODULE_CONFIG;
    this.headerMenuLinks = SUBMENU_NAV;
    this.profileIcon = profileIcon;
    this.langIcon = langIcon;
    this.languageIcon = languageIcon;
    const isLoggedIn = !!this.msalService.instance.getActiveAccount();
    this.isLoggedIn = isLoggedIn;
    this.activeLang = this.transloco.getActiveLang();
    this.transloco.selectTranslation('fr').subscribe((x) => (this.activeLang = this.transloco.getActiveLang()));

    this.surveysEnabled = false;

    this.surveysService.isEnabled()
      .pipe(take(1))
      .subscribe({
        next: (enabled) => {
          this.surveysEnabled = enabled === true;
        },
        error: () => {
          this.surveysEnabled = false;
        }
      });

    // Ensure integration badge count is tracked
    this.intDashSvc.capturedIntegrationCount$.subscribe((count) => {
      this.globals.dashCount = count;
    });


/*    await this.userStateSvc.modules$.forEach((item) => {
      item.forEach((nav) => {
        if (nav.key == 'integration') {

        }
      })
    });*/
  }

  public ngOnDestroy(): void {
    // unsubscribe from service events
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  public isActive(module: string): boolean {
    if (module !== undefined && module.startsWith('/')) module = module.substring(1, module.length);

    if (this.globals.activeModule !== undefined && this.activeModule === undefined)
      this.activeModule = this.globals.activeModule;

    if (module === undefined || this.activeModule === undefined) return false;
    return module === this.activeModule;
  }

  public isSubactive(module: string): boolean {
    if (module !== undefined && module.startsWith('/')) module = module.substring(1, module.length);

    if (this.globals.activeSubModule !== undefined && this.activeSubModule === undefined)
      this.activeSubModule = this.globals.activeSubModule;

    if (module === undefined || this.activeSubModule === undefined) return false;
    return module === this.activeSubModule;
  }

  public childActive(module: NavListModule): boolean {
    if (module === undefined || module.children === undefined || module.children.length === 0) return false;

    // is this module active?
    if (module.key !== this.activeModule) return false;

    // do we need to have a parent key?
    let parentRequired = '';

    module.children.forEach((child) => {
      if (child.parent !== undefined && child.parent.length > 0) {
        parentRequired = child.parent;
      }
    });

    switch (parentRequired.toLowerCase()) {
      case '': {
        return true;
      }
      case 'casekey': {
        if (this.globals.caseKey > 0) return true;
      }
    }

    return false;
  }

  getExternalUrl(path: string) {
    return getBaseUrlClean() + path;
  }

  switchLanguage(lang: string) {
    localStorage.setItem('LangPref', lang);
    window.location.reload();
  }
}